import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Router, Route } from "react-router-dom";
// import createHistory from "history/createHashHistory";
import { createHashHistory } from 'history';
import Login from "./views/Login";
import ProjectsPage from "./views/ProjectsPage";
import TeamBatch from "./views/TeamBatch";
import MemberProfile from "./components/MemberProfile";
import Recruitment from "./views/Recruitment";
import UserDashboard from "./views/UserDashboard";
import AdminDashboard from "./views/AdminDashboard";
import AdminLogin from "./views/AdminLogin";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "semantic-ui-css/semantic.min.css";
import SignUp from "./views/SignUp";
import Gallery from "./views/Gallery";

ReactDOM.render(
  <Router
    history={createHashHistory({ queryKey: true })}
    onUpdate={() => window.scrollTo(0, 0)}
    basename={process.env.PUBLIC_URL}
  >
    <Route exact path="/" component={App} />
    <Route path="/login" component={Login} />
    <Route path="/projects" component={ProjectsPage} />
    <Route path="/team" component={TeamBatch} />
    <Route path="/gallery" component={Gallery} />
    <Route path="/recruitment" component={Recruitment} />
    <Route path="/member" component={MemberProfile} />
    <Route path="/VrfHpcV3wHQHFD5" component={UserDashboard} />
    <Route path="/VZpy2ZU2JzQzgNAq" component={AdminLogin} />
    <Route path='/vpMUN7G54pff7CA7' component={AdminDashboard} />
      
    <Route path='/v4ffZutsJVvTT9' component={SignUp} />
      
    <Route path='/VYr6Wzy8Tc' component={Login} /> {/*// Redirecting signUp to Login page to stop registrations */}
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
